import React from "react";
import { isPdf } from "../domain/fileUtils";

const ViewDocButton = ({ url, label, className, style }) => {
    if (!url) return <span>—</span>;
    const text = label ?? (isPdf(url) ? "Ver PDF" : "Ver imagen");

    return (
        <a
            className={className ?? "add-button-global"}
            style={style ?? { padding: "6px 10px", fontSize: 13 }}
            href={url}
            target="_blank"
            rel="noreferrer"
        >
            {text}
        </a>
    );
};

export default ViewDocButton;
